import React from 'react';
import { Helmet } from 'react-helmet-async';
import Services from '../components/Services';

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://wayug.com/' },
    { '@type': 'ListItem', position: 2, name: 'Services', item: 'https://wayug.com/services' },
  ],
};

const ServicesPage = () => {
  return (
    <div className="page-content subpage-content">
      <Helmet>
        <title>Cloud, Cybersecurity, AI &amp; Software Services | Wayug Infotech</title>
        <meta
          name="description"
          content="Enterprise-grade cloud migration, zero-trust cybersecurity, AI automation and custom software development in India. Get a free IT assessment from Wayug Infotech today."
        />
        <link rel="canonical" href="https://wayug.com/services" />
        <meta property="og:title" content="Cloud, Cybersecurity, AI &amp; Software Services | Wayug Infotech" />
        <meta
          property="og:description"
          content="Explore our end-to-end IT services — AWS/Azure cloud, zero-trust security, AI/ML, custom software, and 24/7 managed services for enterprises."
        />
        <meta property="og:url" content="https://wayug.com/services" />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
      </Helmet>
      <Services />
    </div>
  );
};

export default ServicesPage;
